module.exports = __webpack_public_path__ + "1eb9c927b70115bd85190fc4bce47f15.svg";